<template>
  <v-card>
    <v-container fluid grid-list-xl>
      <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
      <span class="caption">{{$t('message.onedriveSettings.oneDriveSetup')}}</span>
      <v-layout wrap class="pa-3">
        <v-row v-if="!loading">
          <v-col cols="12">
            <v-autocomplete autocomplete="off" :label="$t('message.onedriveSettings.selectHse')" v-model="savedSettings.hse_base_folder_id" :items="onedriveRootItems" item-text="name" item-value="id">
            </v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete autocomplete="off" :label="$t('message.onedriveSettings.selectProduct')" :loading="loadingChildren" v-model="savedSettings.product_base_folder_id" :items="onedriveRootChildren" item-text="name" item-value="id">
            </v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete autocomplete="off" :label="$t('message.onedriveSettings.selectCustomer')" :loading="loadingChildren" v-model="savedSettings.customer_base_folder_id" :items="onedriveRootChildren" item-text="name" item-value="id">
            </v-autocomplete>
          </v-col>
          <v-col md="4">
            <v-btn @click="saveForm()" class="primary ma-3">{{$t('message.common.save')}}</v-btn>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
export default {
  'name': 'OneDriveSetting',
  data () {
    return {
      loading: true,
      onedriveRootItems: [],
      onedriveRootChildren: [],
      savedSettings: {},
      loadingChildren: false
    }
  },
  mounted () {
    this.checkODRegistrationAndProceed()
  },
  watch: {
    'savedSettings.hse_base_folder_id' (val) {
      this.getODRootsChildren()
    }
  },
  methods: {
    checkODRegistrationAndProceed () {
      this.$_executeApi('get', 'onedrivesettings/get_my_tokens')
        .then((response) => {
          if (response.data) {
            this.getSetConfiguredItems()
          } else {
            this.$_executeApi('get', 'onedrivesettings/get_auth_url')
              .then((response1) => {
                window.location.href = response1.data
              })
          }
        })
    },
    getSetConfiguredItems () {
      this.$_executeApi('get', 'onedrivesettings')
        .then((response) => {
          this.savedSettings = response.data
        })
        .finally(() => {
          this.getODRootItems()
        })
    },
    getODRootItems () {
      this.$_executeApi('get', 'onedrivesettings/get_root_folders')
        .then((response) => {
          this.onedriveRootItems = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    getODRootsChildren () {
      this.loadingChildren = true
      this.$_executeApi('get', `hse/get_children_folders/${this.savedSettings.hse_base_folder_id}`)
        .then((response) => {
          this.onedriveRootChildren = response.data
        })
        .finally(() => {
          this.loading = false
          this.loadingChildren = false
        })
    },
    saveForm () {
      let model = this.savedSettings
      this.$_executeApi('post', 'onedrivesettings', model)
        .then((response) => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.savedSuccess') })
        })
    }
  }
}
</script>
